import React, { useMemo } from "react";
import { Row, Col } from "react-bootstrap";

import { withFeeBlockContext } from "../../feeBlockContext";
import TemplateField from "../../templateField";
import getValidator from "../../validators";

const GatewayBlock = ({
	isMerchant = false,
	isFiservFspProcessor = false,
	isPaperApplication = false,
}) => {
	const validators = useMemo(
		() => getValidator(!isPaperApplication),
		[isPaperApplication],
	);

	return (
		<>
			<Row>
				<Col md={5}>
					<TemplateField
						name="gatewayPerAuth"
						label="Gateway per Auth, $"
						hideRequiredMark
						placeholder="0.000000"
						placeholderClassName={
							isPaperApplication
								? "placeholder-value"
								: "placeholder-primary"
						}
						{...validators.gatewayPerAuth}
						disabled={!isMerchant && isFiservFspProcessor}
						isPlainText={!isMerchant && isFiservFspProcessor}
					/>
				</Col>
			</Row>
			<Row>
				<Col md={5}>
					<TemplateField
						name="gatewayAdjustmentsFee"
						label="Gateway Adjustments Fee, $"
						hideRequiredMark
						placeholder="0.000000"
						placeholderClassName={
							isPaperApplication
								? "placeholder-value"
								: "placeholder-primary"
						}
						{...validators.gatewayAdjustmentsFee}
					/>
				</Col>
				<Col md={{ span: 5, offset: 2 }}>
					<TemplateField
						name="gatewayDepositFee"
						label="Gateway Deposit Fee, $"
						hideRequiredMark
						placeholder="0.000000"
						placeholderClassName={
							isPaperApplication
								? "placeholder-value"
								: "placeholder-primary"
						}
						{...validators.gatewayDepositFee}
					/>
				</Col>
			</Row>
		</>
	);
};

export default withFeeBlockContext("Gateway")(GatewayBlock);
